const AboutApp  = 
[{
  "name": "JEE Prep App",
  "title": "JEE Exam PYQ, Practics Questions, Mock Test",
  "link": "https://play.google.com/store/apps/details?id=com.mystudyplace.jeemocktest",
  "symbol": "./../../logo.png",
  "supportEmail": "support@mystudyplace.in",
 // "address": "Suti, Murshidabad, WestBangal, India, 742201"
  
}
]




export default  AboutApp;